import React from 'react';
import { HANDICAPTYPE } from "../../../shared/constants/constants";

class Scoreboard_10B extends React.Component {

  constructor(props) {
		super(props);
		this.createRow = this.createRow.bind(this);
	}

	render() {
		//console.log('Scoreboard_10B: RENDER')
		return (
			<div className="table-responsive">
				<h3>Sommaire</h3>
				<table className="table">
					<tbody>
						<tr>
							<td><strong> RONDES </strong></td>
							<td><strong> Local </strong></td>
							<td><strong> Visiteur </strong></td>
						</tr>
						{this.props.rounds.map(this.createRow)}
						{this.dispHandicap()}
						<tr>
							<td>Points totaux</td>
							<td>{this.props.team1TotalPts}</td>
							<td>{this.props.team2TotalPts}</td>
						</tr>
						<tr><td>&nbsp;</td><td></td><td></td></tr>
						<tr><td><strong>TOTAUX</strong></td><td></td><td></td></tr>
						<tr>
							<td>TRO</td>
							<td>{this.props.team1TotalEro}</td>
							<td>{this.props.team2TotalEro}</td>
						</tr>
						<tr>
							<td>TenBall-Break</td>
							<td>{this.props.team1TotalTbb}</td>
							<td>{this.props.team2TotalTbb}</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}

	createRow(round) {
		var description = round.description;
		return (
			<tr key={round.roundNumber}>
				<td>{description}</td>
				<td>{round.team1Pts}</td>
				<td>{round.team2Pts}</td>
			</tr>
		);
	}

	dispHandicap() {
		// only when handicap is for the match points
		if ((this.props.handicapType === HANDICAPTYPE.SCAB) ||
			  (this.props.handicapType === HANDICAPTYPE.PARTIES)) {
			
			return (
				<tr>
					<td>Handicap</td>
					<td>{this.props.team1HandicapPts}</td>
					<td>{this.props.team2HandicapPts}</td>
				</tr>
			)
		}
	}

}

export default Scoreboard_10B;